import React, { FC, PropsWithChildren, useEffect, useMemo } from 'react';
import { ITitleService } from '../titleService';

export const TitleServiceContext = React.createContext<ITitleService | undefined>(undefined);

export type ITitleServiceProps = {
    titleService?: ITitleService;
    title?: string;
};

export const TitleServiceProvider: FC<PropsWithChildren<ITitleServiceProps>> = (props) => {
    const { children, titleService, title } = props;
    const currentTitleService = React.useContext(TitleServiceContext);

    const finalService = useMemo(() => {
        let service = currentTitleService ?? titleService;

        if (!service) {
            throw new Error('TitleService is not provided in the DashboardServices context');
        }

        if (title) {
            service = service.createSubTitleService(title);
        }

        return service;
    }, [titleService, currentTitleService, title]);

    useEffect(() => {
        finalService.applyTitle();
    }, [finalService]);

    return (
        <TitleServiceContext.Provider value={finalService}>{children}</TitleServiceContext.Provider>
    );
};
